import script from "./scrollBar.vue?vue&type=script&setup=true&lang=js"
export * from "./scrollBar.vue?vue&type=script&setup=true&lang=js"

import "./scrollBar.vue?vue&type=style&index=0&id=5397b233&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5397b233"]])

export default __exports__